export default __webpack_public_path__ + "static/logo-a05b430fedbc0ce64c5402b580d241d0.png";